var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueHi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 292 395",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2554.24,-71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.54747e-13,1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2584.44,-509.332L2583.55,-509.369L2580.67,-544.719C2580.37,-548.357 2577.18,-551.066 2573.54,-550.769C2573.45,-550.761 2573.35,-550.754 2573.26,-550.746C2569.62,-550.449 2566.91,-547.258 2567.21,-543.62L2570.01,-509.268C2569.96,-509.255 2569.91,-509.241 2569.86,-509.227L2567.66,-522.236C2567.04,-525.865 2563.6,-528.309 2559.97,-527.694C2559.91,-527.684 2559.86,-527.674 2559.8,-527.664C2556.17,-527.049 2553.72,-523.609 2554.34,-519.98L2559.39,-490.157C2559.81,-484.318 2560.49,-477.497 2561.05,-472.228C2561.54,-467.424 2563.6,-462.916 2566.92,-459.405C2569.81,-456.487 2572.67,-451.84 2572.28,-445.609L2592.82,-445.609C2592.82,-445.609 2596.37,-453.641 2602.01,-456.823C2602.08,-456.864 2602.15,-456.905 2602.22,-456.946C2602.72,-457.054 2603.21,-457.233 2603.67,-457.489C2603.67,-457.489 2616.33,-464.429 2625.57,-469.492C2628.09,-470.871 2629.95,-473.193 2630.76,-475.947C2631.56,-478.701 2631.24,-481.661 2629.86,-484.177C2629.86,-484.183 2629.85,-484.188 2629.85,-484.194C2628.47,-486.71 2626.15,-488.575 2623.4,-489.379C2620.64,-490.183 2617.68,-489.86 2615.17,-488.481L2609.34,-485.289L2609.72,-493.499C2609.74,-493.914 2609.74,-494.327 2609.72,-494.738C2609.8,-494.964 2609.86,-495.201 2609.9,-495.448C2609.9,-495.448 2614.11,-523.842 2616.08,-537.103C2616.62,-540.79 2614.08,-544.222 2610.39,-544.769C2610.39,-544.77 2610.38,-544.77 2610.38,-544.771C2606.69,-545.317 2603.26,-542.772 2602.71,-539.085L2598.18,-508.533C2598.1,-508.552 2598.01,-508.569 2597.93,-508.586L2599.41,-548.616C2599.55,-552.341 2596.65,-555.473 2592.92,-555.611C2592.92,-555.611 2592.91,-555.611 2592.91,-555.612C2589.19,-555.75 2586.05,-552.843 2585.92,-549.118L2584.44,-509.332Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.60339,0,0,7.48384,-26326.8,-46211.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4400,6130C4400,6130 4390.66,6131.22 4386.55,6131.75C4385.48,6131.89 4384.71,6132.73 4384.78,6133.69C4385.14,6138.57 4414.84,6138.56 4415.18,6133.68C4415.25,6132.73 4414.48,6131.89 4413.41,6131.75C4409.32,6131.22 4400,6130 4400,6130Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.8466,2.29568,-2.48849,20.4296,-65033.9,-135203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4402,6096C4404.21,6096 4406,6097.79 4406,6100C4406,6101.28 4408.31,6107.07 4406.16,6109.49C4404.59,6111.26 4398.6,6109.99 4397.67,6109.99C4395.46,6109.99 4398,6102.21 4398,6100C4398,6097.79 4399.79,6096 4402,6096Z",
    style: {
      fill: "rgb(255,167,98)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.54747e-13,-630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2825.18,150.233C2825.24,154.24 2825.03,158.313 2824.53,162.422C2821.35,188.545 2850.55,312.168 2803.86,356.751C2790.17,369.817 2764.15,371.177 2736.83,368.01C2745.95,338.747 2753.83,312.022 2753.7,297.038C2753.24,245.539 2801.6,195.39 2823.99,152.237C2824.38,151.502 2824.77,150.835 2825.18,150.233Z",
    style: {
      fill: "rgb(216,132,66)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.42893,0.904906,-1.43405,11.773,-21167.2,-76463.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6125L4395,6130C4398.33,6131.9 4401.67,6131.93 4405,6130L4404,6125L4396,6125Z",
    style: {
      fill: "rgb(255,193,151)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.42893,0.904906,-0.904906,7.42893,-24422.7,-49822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6110.03C4412,6109.75 4411.89,6109.49 4411.7,6109.3C4411.51,6109.11 4411.25,6109 4410.97,6109L4410,6109L4409.31,6113L4410,6113C4411.11,6113 4412,6112.11 4412,6111C4412,6110.66 4412,6110.32 4412,6110.03Z",
    style: {
      fill: "rgb(179,97,42)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.42893,0.904906,-0.452453,3.71447,-27195.1,-27123.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6110.09C4412,6109.8 4411.94,6109.52 4411.84,6109.32C4411.74,6109.11 4411.6,6109 4411.45,6109C4410.86,6109 4410,6109 4410,6109L4410,6113C4410,6113 4410.44,6113.02 4410.9,6113.05C4411.19,6113.06 4411.47,6112.84 4411.68,6112.44C4411.88,6112.04 4412,6111.48 4412,6110.91C4412,6110.62 4412,6110.35 4412,6110.09Z",
    style: {
      fill: "rgb(195,111,55)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.42893,0.904906,-0.904906,7.42893,-24402.3,-49819.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4389,6109C4388.45,6109 4388,6109.45 4388,6110C4388,6110.3 4388,6110.65 4388,6111C4388,6112.11 4388.9,6113 4390,6113C4390,6113 4390.5,6113 4390.5,6113L4390,6109Z",
    style: {
      fill: "rgb(222,137,81)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.42893,0.904906,-0.452453,3.71447,-27159.8,-27119.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4388.55,6109C4388.4,6109 4388.26,6109.11 4388.16,6109.32C4388.06,6109.52 4388,6109.8 4388,6110.09L4388,6110.86C4388,6112.04 4388.48,6113 4389.07,6113L4390,6113L4390,6109Z",
    style: {
      fill: "rgb(195,111,55)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.54747e-13,-630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2702.37,271.804L2706.82,254.148L2766.25,261.387L2766.33,278.862L2751.87,289.634C2739.61,298.771 2722.33,296.578 2712.74,284.67L2702.37,271.804Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.96227,0.848063,-0.714223,5.86349,-23524.3,-40005.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390.73,6108.77C4390.73,6103.93 4393.93,6100 4398.77,6100C4399.59,6100 4400.41,6100 4401.23,6100C4406.07,6100 4409.27,6103.93 4409.27,6108.77C4409.27,6109.76 4409.01,6112.55 4408.71,6115.44C4408.38,6120.38 4405.6,6124.6 4401.65,6126.19C4401.65,6126.21 4401.65,6126.21 4401.65,6126.21C4400.58,6126.64 4399.42,6126.64 4398.35,6126.21C4398.35,6126.21 4398.35,6126.21 4398.35,6126.21C4394.39,6124.62 4391.61,6120.39 4391.27,6115.44C4390.99,6112.54 4390.73,6109.76 4390.73,6108.77Z",
    style: {
      fill: "rgb(255,193,151)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.82391,0.465784,-0.489621,4.0196,-11091.7,-27040.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4399.73,6112C4399.32,6112 4398,6115.49 4398,6115.67C4398,6115.86 4398,6116.08 4398,6116.27C4398,6116.68 4398.32,6117 4398.73,6117C4399.45,6117 4400.55,6117 4401.27,6117C4401.68,6117 4402,6116.68 4402,6116.27L4402,6115.67C4402,6115.49 4400.68,6112 4400.27,6112C4400.1,6112 4399.9,6112 4399.73,6112Z",
    style: {
      fill: "rgb(255,158,94)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.0105,0.853937,-0.709388,5.8238,-23768.2,-39785.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6119L4404,6119L4404,6119C4404,6120.66 4402.66,6122 4401,6122C4400.35,6122 4399.65,6122 4399,6122C4397.34,6122 4396,6120.66 4396,6119C4396,6119 4396,6119 4396,6119Z",
    style: {
      fill: "rgb(46,18,0)",
      fillOpacity: 0.7
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.54747e-13,-630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2709.19,233.975L2765.28,240.807C2765.28,240.807 2765.28,240.807 2765.28,240.807C2764.89,243.987 2763.5,246.845 2761.4,249.196C2761.35,249.192 2761.29,249.187 2761.24,249.18C2751.52,247.997 2720.82,244.257 2711.11,243.074C2711.05,243.067 2711,243.059 2710.94,243.049C2709.47,240.262 2708.81,237.156 2709.19,233.976L2709.19,233.975Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.54747e-13,-630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2713.13,246.275L2758.5,251.802C2754.22,254.907 2748.35,256.475 2742.12,255.717C2737.53,255.158 2732.68,254.567 2728.1,254.009C2721.87,253.25 2716.55,250.318 2713.13,246.275Z",
    style: {
      fill: "rgb(161,45,43)",
      fillOpacity: 0.7
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.42893,0.904906,-0.904906,7.42893,-24409.4,-49818.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4394,6110.78C4394,6110.35 4394.35,6110 4394.78,6110C4394.93,6110 4395.07,6110 4395.22,6110C4395.65,6110 4396,6110.35 4396,6110.78C4396,6111.23 4396,6111.77 4396,6112.22C4396,6112.65 4395.65,6113 4395.22,6113C4395.07,6113 4394.93,6113 4394.78,6113C4394.35,6113 4394,6112.65 4394,6112.22C4394,6111.77 4394,6111.23 4394,6110.78Z",
    style: {
      fill: "rgb(46,12,12)",
      fillOpacity: 0.53
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.42893,0.904906,-0.904906,7.42893,-24345.3,-49810.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4394,6110.78C4394,6110.35 4394.35,6110 4394.78,6110C4394.93,6110 4395.07,6110 4395.22,6110C4395.65,6110 4396,6110.35 4396,6110.78C4396,6111.23 4396,6111.77 4396,6112.22C4396,6112.65 4395.65,6113 4395.22,6113C4395.07,6113 4394.93,6113 4394.78,6113C4394.35,6113 4394,6112.65 4394,6112.22C4394,6111.77 4394,6111.23 4394,6110.78Z",
    style: {
      fill: "rgb(46,12,12)",
      fillOpacity: 0.53
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.42893,0.904906,-0.904906,7.42893,-24407.9,-49830.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4393,6109.5C4393,6109.37 4393.05,6109.24 4393.15,6109.15C4393.24,6109.05 4393.37,6109 4393.5,6109C4394.27,6109 4395.73,6109 4396.5,6109C4396.63,6109 4396.76,6109.05 4396.85,6109.15C4396.95,6109.24 4397,6109.37 4397,6109.5C4397,6109.63 4396.95,6109.76 4396.85,6109.85C4396.76,6109.95 4396.63,6110 4396.5,6110C4395.73,6110 4394.27,6110 4393.5,6110C4393.37,6110 4393.24,6109.95 4393.15,6109.85C4393.05,6109.76 4393,6109.63 4393,6109.5Z",
    style: {
      fill: "rgb(121,71,32)",
      fillOpacity: 0.53
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.42893,0.904906,-0.904906,7.42893,-24418.1,-49832.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4403,6109.5C4403,6109.37 4403.05,6109.24 4403.15,6109.15C4403.24,6109.05 4403.37,6109 4403.5,6109C4404.27,6109 4405.73,6109 4406.5,6109C4406.63,6109 4406.76,6109.05 4406.85,6109.15C4406.95,6109.24 4407,6109.37 4407,6109.5C4407,6109.63 4406.95,6109.76 4406.85,6109.85C4406.76,6109.95 4406.63,6110 4406.5,6110C4405.73,6110 4404.27,6110 4403.5,6110C4403.37,6110 4403.24,6109.95 4403.15,6109.85C4403.05,6109.76 4403,6109.63 4403,6109.5Z",
    style: {
      fill: "rgb(121,71,32)",
      fillOpacity: 0.53
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.09854,0.621045,-0.621045,5.09854,9040.25,-1164.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1212.31,285C-1205.27,283.17 -1197.27,280.57 -1194.5,275.5C-1192.34,279.652 -1191.65,282.673 -1187,285.056L-1186,281L-1192,273L-1201,272L-1208,274L-1212,278L-1212.31,285Z",
    style: {
      fill: "rgb(255,167,98)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.54747e-13,630)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1522.24,-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1105.72,-236.015C1105.61,-247.644 1096.64,-257.265 1085.05,-258.197C1073.22,-259.148 1060.66,-260.158 1060.66,-260.158C1047.61,-268.607 1039.63,-283.022 1039.41,-298.574C1038.85,-338.602 1037.77,-415.043 1037.46,-437.28C1037.44,-438.919 1038.07,-440.499 1039.22,-441.666C1040.37,-442.833 1041.94,-443.491 1043.58,-443.49C1052.46,-443.49 1068.64,-443.49 1077.25,-443.49C1080.48,-443.491 1083.16,-440.981 1083.37,-437.756C1084.3,-423.128 1086.83,-383.559 1088.65,-354.925C1089.17,-346.732 1093.15,-339.147 1099.6,-334.06C1106.04,-328.974 1114.35,-326.865 1122.44,-328.26C1142.7,-331.753 1173.31,-336.653 1173.31,-336.653C1179.81,-296.377 1227.94,-295.205 1245.21,-336.653C1245.21,-336.653 1257.83,-333.062 1287.96,-328.15C1306.38,-325.149 1324.03,-292.985 1323.5,-274.335C1321.44,-202.046 1323.5,-160 1323.5,-160L1106.46,-160C1106.46,-160 1106,-207.666 1105.72,-236.015Z",
    style: {
      fill: "rgb(14,164,233)"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHi);
export default __webpack_public_path__ + "static/media/blue_hi.926851eddb9d05d3e08613f8a316c20c.svg";
export { ForwardRef as ReactComponent };